import React from "react";
import styles from "./index.module.scss";
import classNames from "classnames";
import { Icon } from "antd";

interface InfoCardProps {
    variant: "warn" | "normal";
    title: string;
    desc: string;
    count?: number;
    onClick: () => void;
}

export default function InfoCard({
    variant,
    title,
    count,
    desc,
    onClick
}: InfoCardProps) {
    return (
        <div
            className={classNames(styles.root, styles[`bg-${variant}`])}
            onClick={onClick}>
            {variant === "warn" && (
                <div className={styles.tip}>
                    <Icon
                        type="exclamation-circle"
                        style={{ marginRight: 10 }}
                    />
                </div>
            )}

            <div className={styles.title}>
                {title} {count && <span>{count}人</span>}
            </div>

            <div className={styles.desc}>{desc}</div>
        </div>
    );
}
